

















































































































































import http from "@/axios/http-common";
import { refResepStore } from "@/store/modules/ReferensiResep";
import { Vue, Component, Prop, Watch, Ref } from "vue-property-decorator";
import ObatSearchBox from "@/components/resep/ObatSearchBox.vue";

interface ObatRacikan {
  type: "rc";
  obat_nama: string;
  nama: string;
  qty: number;
  qty_unit: string;
  // signa: string;
  harga: number;
  countedHarga: number;
  obat_id: string;
  ap_rute: string;
  ap_frekuensi: string;
  ap_dosis: string;
  ap_tambahan: string;
  ap_template_id: string;
  ap_template_nama: string;
  r: string;
  frekuensi_id: string;
  rute_id: string;
  sediaan_id: string;
  frekuensi?: {
    id: number;
    nama: string;
  };
  rute?: {
    id: number;
    nama: string;
  };
  sediaan?: {
    id: number;
    nama: string;
  };
  items: ItemObatRacikan[];
}

interface ItemObatRacikan {
  obat_id: string;
  obat_nama: string;
  qty: number;
  qty_unit: string;
  ap_dosis: string;
  r: string;
  ap_tambahan: string;
  ap_template_id: string;
  frekuensi_id: number;
  rute_id: number;
}

@Component({
  components: {
    ObatSearchBox
  }
})
export default class ObatRacikanRowRanap extends Vue {
  // public obatEntries = [];
  // public obatLoading = false;
  // public obatModel = null;
  // public obatSearch = null;
  public rules = {
    required: value => !!value || "Kolom ini harus diisi"
  };
  loading = false;
  items = [];
  val = "";
  search = null;
  select = null;
  list = [{ val: null, search: null }];
  entries = [];
  signaLoading = false;
  // _timerId;

  @Prop() item: ObatRacikan;

  @Prop() index: number;

  @Prop() color: string;

  @Ref() readonly obatSearchBox!: ObatSearchBox;

  mounted() {
    this.$nextTick(() => {
      this.obatSearchBox.focus();
    });
  }

  get refRute() {
    return refResepStore.refRute;
  }

  get refFrekuensi() {
    return refResepStore.refFrekuensi;
  }

  get refSediaan() {
    return refResepStore.refSediaan;
  }

  triggerSubmit() {
    this.$emit("trigger-submit");
  }

  removeItem(index) {
    this.$emit("remove-item", index);
  }

  handleSelectObat(val) {
    this.addObat(val);
    this.$nextTick(() => {
      setTimeout(() => {
        this.obatSearchBox.focus();
      }, 200);
    });
  }

  addObat(obat) {
    this.item.items.push({
      obat_nama: obat.nama,
      ap_dosis: "",
      r: this.item.r,
      obat_id: obat.id,
      qty: null,
      qty_unit: null,
      ap_tambahan: null,
      ap_template_id: null,
      frekuensi_id: null,
      rute_id: null
    });
  }

  removeKomponenItem(index) {
    this.item.items.splice(index, 1);
  }
}
